import axios from "axios";

export const loginUser = async (email, password) => {
  const { data, status } = await axios.post(
    "https://api.meetmontenegro.me/users/authenticate",
    {
      email,
      password,
    }
  );

  return { data, status };
};
